export function hasCalendarItemCardDetails({ address, people }) {
  return Boolean(address) || people.length > 0
}

export function hasCalendarItemCardDetailsSeparator({ address, people }) {
  return Boolean(address) && people.length > 0
}
